import PortalIdParser from 'PortalIdParser';
import { OBJECT_TYPE } from 'asset-actions-lib/constants/objectTypes';
import { getPropertyValue } from './crmObject';
export function getCompareRoute(crmObject) {
  switch (crmObject.objectTypeId) {
    case OBJECT_TYPE.CAMPAIGN:
      return `/marketing/${PortalIdParser.get()}/campaigns/compare?id=${getPropertyValue(crmObject, 'hs_origin_asset_id')}`;
    case OBJECT_TYPE.MARKETING_EMAIL:
      return `/email/${PortalIdParser.get()}/compare?id=${getPropertyValue(crmObject, 'hs_origin_asset_id')}`;
    case OBJECT_TYPE.MARKETING_SMS:
      return `/sms/${PortalIdParser.get()}/compare?id=${getPropertyValue(crmObject, 'hs_content_id')}`;
    case OBJECT_TYPE.FORM:
      return `/forms/${PortalIdParser.get()}/compare?id=${getPropertyValue(crmObject, 'hs_form_id')}`;
    default:
      return undefined;
  }
}